import require_nocredentials from '../utils/require_nocredentials'
export function getRoutes(data) {
  return require_nocredentials({
    url: '/api/route/getRoutes',
    method: 'post',
    data: data
  })
}
export function getSingleRoutes(data) {
  return require_nocredentials({
    url: '/api/route/'+ data,
    method: 'get',
  })
}



// WEBPACK FOOTER //
// ./src/services/billSearch.js